module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Map/Marker#2-12aa53526f5f9ac57f979a82b6e5224cd7811be2f2cc8a4e5d23d87020e64540.svg";